/* YRHAND - Shared interactive scripts (vanilla JS) */

(function () {
  'use strict';

  // ---------- Theme (light/dark) ----------
  const THEME_KEY = 'yrhand-theme';
  function applyTheme(theme) {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }
  const savedTheme = localStorage.getItem(THEME_KEY);
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
    applyTheme('dark');
  }
  window.toggleTheme = function () {
    const isDark = document.documentElement.classList.contains('dark');
    const next = isDark ? 'light' : 'dark';
    applyTheme(next);
    localStorage.setItem(THEME_KEY, next);
    // Sync the toggle button's aria-label and pressed state to the new theme.
    const btn = document.getElementById('theme-toggle');
    if (btn) {
      btn.setAttribute('aria-label', next === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      btn.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
    }
    document.dispatchEvent(new CustomEvent('themechange', { detail: { theme: next } }));
  };

  // On first paint, set the toggle button's aria-label to match the initial theme
  // (avoids "Toggle theme" being wrong if the user lands in dark mode by default).
  (function syncInitialToggleLabel() {
    const btn = document.getElementById('theme-toggle');
    if (!btn) return;
    const isDark = document.documentElement.classList.contains('dark');
    btn.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
    btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
  })();

  // ---------- Mobile menu ----------
  window.openMobileMenu = function (id) {
    const el = document.getElementById(id);
    if (el) el.style.transform = 'translateX(0)';
    document.body.style.overflow = 'hidden';
  };
  window.closeMobileMenu = function (id) {
    const el = document.getElementById(id);
    if (el) el.style.transform = 'translateX(-100%)';
    document.body.style.overflow = '';
  };

  // ---------- Announcement rotator ----------
  document.querySelectorAll('[data-announcement]').forEach((root) => {
    const items = root.querySelectorAll('[data-announcement-item]');
    if (items.length <= 1) return;
    let i = 0;
    setInterval(() => {
      items[i].style.transform = 'translateY(-100%)';
      items[i].style.opacity = '0';
      i = (i + 1) % items.length;
      items[i].style.transform = 'translateY(0)';
      items[i].style.opacity = '1';
    }, 4000);
    items.forEach((it, idx) => {
      it.style.transition = 'all 0.5s';
      if (idx !== 0) {
        it.style.transform = 'translateY(100%)';
        it.style.opacity = '0';
      } else {
        it.style.transform = 'translateY(0)';
        it.style.opacity = '1';
      }
    });
  });

  // ---------- Sticky navbar scroll shadow ----------
  const stickyNavs = document.querySelectorAll('[data-sticky-nav]');
  if (stickyNavs.length) {
    const onScroll = () => {
      stickyNavs.forEach((nav) => {
        if (window.scrollY > 10) {
          nav.classList.add('is-scrolled');
        } else {
          nav.classList.remove('is-scrolled');
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Reveal on scroll ----------
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    reveals.forEach((el) => io.observe(el));
  }

  // ---------- Animated counters ----------
  document.querySelectorAll('[data-counter]').forEach((el) => {
    const target = parseFloat(el.dataset.counter);
    const suffix = el.dataset.suffix || '';
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    let started = false;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started) {
          started = true;
          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              el.textContent = target + suffix;
              clearInterval(timer);
            } else {
              el.textContent = Math.floor(current) + suffix;
            }
          }, duration / steps);
          io.unobserve(el);
        }
      },
      { threshold: 0.5 }
    );
    io.observe(el);
  });

  // ---------- FAQ accordion (category tabs + collapse) ----------
  window.setFaqCategory = function (rootId, category) {
    const root = document.getElementById(rootId);
    if (!root) return;
    root.querySelectorAll('[data-faq-cat]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.faqCat === category);
    });
    root.querySelectorAll('[data-faq-group]').forEach((group) => {
      group.classList.toggle('hidden', group.dataset.faqGroup !== category);
    });
  };
  window.toggleFaq = function (id) {
    const item = document.getElementById(id);
    if (!item) return;
    const isOpen = item.classList.contains('is-open');
    const content = item.querySelector('[data-faq-content]');
    const chevron = item.querySelector('[data-faq-chevron]');
    if (isOpen) {
      item.classList.remove('is-open');
      if (content) content.style.gridTemplateRows = '0fr';
      if (chevron) chevron.style.transform = 'rotate(0deg)';
    } else {
      item.classList.add('is-open');
      if (content) content.style.gridTemplateRows = '1fr';
      if (chevron) chevron.style.transform = 'rotate(180deg)';
    }
  };

  // ---------- Quiz ----------
  const quizData = {
    questions: [
      {
        id: 1, question: 'Where will you use the lock?',
        options: [
          { id: 'home', label: 'Home', description: 'Primary residence' },
          { id: 'office', label: 'Office', description: 'Business space' },
          { id: 'airbnb', label: 'Airbnb/Rental', description: 'Short-term rental' },
        ],
      },
      {
        id: 2, question: 'How many people need access?',
        options: [
          { id: 'few', label: '1-2 People', description: 'Just me or couple' },
          { id: 'family', label: '3-5 People', description: 'Family members' },
          { id: 'many', label: '5+ People', description: 'Multiple users' },
        ],
      },
      {
        id: 3, question: "What's most important to you?",
        options: [
          { id: 'security', label: 'Maximum Security', description: 'Top-tier protection' },
          { id: 'smart', label: 'Smart Features', description: 'App control & automation' },
          { id: 'value', label: 'Best Value', description: 'Great quality, fair price' },
        ],
      },
    ],
    recommendations: {
      'home-few-security': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Perfect balance of security and features for your home' },
      'home-few-smart': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Advanced app control and smart home integration' },
      'home-few-value': { name: 'YR-M2 Essential', price: 149, image: 'assets/images/product-m2-essential.jpg', reason: 'Excellent features at a great price point' },
      'home-family-security': { name: 'YR-Z5 Max', price: 299, image: 'assets/images/product-z5-max.jpg', reason: 'Maximum security with multi-user fingerprint support' },
      'home-family-smart': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Easy family access management via app' },
      'home-family-value': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Best features for families at a fair price' },
      'home-many-security': { name: 'YR-Z5 Max', price: 299, image: 'assets/images/product-z5-max.jpg', reason: 'Enterprise-grade security for multiple users' },
      'home-many-smart': { name: 'YR-Z5 Max', price: 299, image: 'assets/images/product-z5-max.jpg', reason: 'Advanced access management for many users' },
      'home-many-value': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Great multi-user features without breaking the bank' },
      'office-few-security': { name: 'YR-Z5 Max', price: 299, image: 'assets/images/product-z5-max.jpg', reason: 'Commercial-grade security for your business' },
      'office-few-smart': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Smart access logs for business tracking' },
      'office-few-value': { name: 'YR-M2 Essential', price: 149, image: 'assets/images/product-m2-essential.jpg', reason: 'Reliable office security at a budget-friendly price' },
      'office-family-security': { name: 'YR-Z5 Max', price: 299, image: 'assets/images/product-z5-max.jpg', reason: 'Multi-user commercial security' },
      'office-family-smart': { name: 'YR-Z5 Max', price: 299, image: 'assets/images/product-z5-max.jpg', reason: 'Smart team access management' },
      'office-family-value': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Professional features at reasonable cost' },
      'office-many-security': { name: 'YR-Z5 Max', price: 299, image: 'assets/images/product-z5-max.jpg', reason: 'Top security for large teams' },
      'office-many-smart': { name: 'YR-Z5 Max', price: 299, image: 'assets/images/product-z5-max.jpg', reason: 'Enterprise access control' },
      'office-many-value': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Best value for growing businesses' },
      'airbnb-few-security': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Secure guest access with easy code changes' },
      'airbnb-few-smart': { name: 'YR-L1 Lite', price: 129, image: 'assets/images/product-l1-lite.jpg', reason: 'Perfect for remote guest management' },
      'airbnb-few-value': { name: 'YR-L1 Lite', price: 129, image: 'assets/images/product-l1-lite.jpg', reason: 'Affordable solution for rental properties' },
      'airbnb-family-security': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Secure multi-guest access' },
      'airbnb-family-smart': { name: 'YR-L1 Lite', price: 129, image: 'assets/images/product-l1-lite.jpg', reason: 'Easy code management for guests' },
      'airbnb-family-value': { name: 'YR-L1 Lite', price: 129, image: 'assets/images/product-l1-lite.jpg', reason: 'Best ROI for rental hosts' },
      'airbnb-many-security': { name: 'YR-X1 Pro', price: 199, image: 'assets/images/product-x1-pro.jpg', reason: 'Secure access for many guests' },
      'airbnb-many-smart': { name: 'YR-L1 Lite', price: 129, image: 'assets/images/product-l1-lite.jpg', reason: 'Scalable code management' },
      'airbnb-many-value': { name: 'YR-L1 Lite', price: 129, image: 'assets/images/product-l1-lite.jpg', reason: 'Affordable at scale' },
    },
  };

  const quizState = { open: false, step: 0, answers: [], showResult: false };
  function renderQuiz() {
    const modal = document.getElementById('quiz-modal');
    if (!modal) return;
    const questionEl = document.getElementById('quiz-question');
    const optionsEl = document.getElementById('quiz-options');
    const progressEl = document.getElementById('quiz-progress');
    const resultEl = document.getElementById('quiz-result');
    const backBtn = document.getElementById('quiz-back');
    if (!questionEl) return;

    if (quizState.showResult) {
      const key = quizState.answers.join('-');
      const rec = quizData.recommendations[key] || quizData.recommendations['home-few-value'];
      resultEl.innerHTML = `
        <div class="text-center">
          <div class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gold/20">
            <svg class="h-6 w-6 text-gold" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
          </div>
          <h3 class="font-serif text-2xl font-bold text-navy dark:text-cream">We Found Your Perfect Lock!</h3>
          <p class="mt-2 text-muted-foreground">Based on your answers, we recommend:</p>
          <div class="mt-6 rounded-xl border border-gold bg-cream/50 dark:bg-navy/50 p-6">
            <div class="mx-auto aspect-square w-32 overflow-hidden rounded-lg bg-white dark:bg-navy">
              <img src="${rec.image}" alt="${rec.name}" class="h-full w-full object-cover" />
            </div>
            <h4 class="mt-4 font-serif text-xl font-bold text-navy dark:text-cream">${rec.name}</h4>
            <p class="mt-1 text-2xl font-bold text-gold">$${rec.price}</p>
            <p class="mt-3 text-sm text-muted-foreground">${rec.reason}</p>
            <button class="btn-gold mt-6 w-full rounded-full" onclick="alert('Added to cart (demo)')">
              <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
              Add to Cart
            </button>
          </div>
          <button onclick="resetQuiz()" class="mt-4 text-sm text-muted-foreground hover:text-navy dark:hover:text-cream">Retake Quiz</button>
        </div>`;
      resultEl.classList.remove('hidden');
      questionEl.parentElement.classList.add('hidden');
      return;
    }

    resultEl.classList.add('hidden');
    questionEl.parentElement.classList.remove('hidden');
    const q = quizData.questions[quizState.step];
    questionEl.textContent = q.question;
    document.getElementById('quiz-step-label').textContent = `Question ${quizState.step + 1} of ${quizData.questions.length}`;
    progressEl.style.width = `${((quizState.step + 1) / quizData.questions.length) * 100}%`;
    optionsEl.innerHTML = q.options.map((opt) => `
      <button onclick="selectQuizOption('${opt.id}')" class="flex w-full items-center gap-4 rounded-xl border-2 p-4 text-left transition-all ${quizState.answers[quizState.step] === opt.id ? 'border-gold bg-cream/50 dark:bg-navy/50' : 'border-border hover:border-gold hover:bg-cream/50 dark:hover:bg-navy/50'}">
        <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-navy/5 dark:bg-gold/10">
          <svg class="h-6 w-6 text-navy dark:text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
        </div>
        <div>
          <p class="font-semibold text-navy dark:text-cream">${opt.label}</p>
          <p class="text-sm text-muted-foreground">${opt.description}</p>
        </div>
      </button>`).join('');
    if (backBtn) backBtn.classList.toggle('hidden', quizState.step === 0);
  }
  window.openQuiz = function () { quizState.open = true; document.getElementById('quiz-modal').classList.remove('hidden'); renderQuiz(); document.body.style.overflow='hidden'; };
  window.closeQuiz = function () { quizState.open = false; document.getElementById('quiz-modal').classList.add('hidden'); document.body.style.overflow=''; setTimeout(resetQuiz, 300); };
  window.selectQuizOption = function (id) {
    quizState.answers[quizState.step] = id;
    if (quizState.step < quizData.questions.length - 1) {
      quizState.step++;
      renderQuiz();
    } else {
      quizState.showResult = true;
      renderQuiz();
    }
  };
  window.quizBack = function () { if (quizState.step > 0) { quizState.step--; renderQuiz(); } };
  window.resetQuiz = function () { quizState.step = 0; quizState.answers = []; quizState.showResult = false; renderQuiz(); };

  // ---------- Product filter ----------
  window.filterProducts = function (cat) {
    document.querySelectorAll('[data-filter]').forEach((b) => b.classList.toggle('is-active', b.dataset.filter === cat));
    document.querySelectorAll('[data-product]').forEach((p) => {
      const cats = (p.dataset.productCats || '').split(',');
      p.classList.toggle('hidden', cat !== 'all' && !cats.includes(cat));
    });
  };

  // ---------- Testimonial carousel ----------
  document.querySelectorAll('[data-testimonials]').forEach((root) => {
    const track = root.querySelector('[data-testimonials-track]');
    const dots = root.querySelectorAll('[data-testimonial-dot]');
    if (!track) return;
    let i = 0;
    const total = track.children.length;
    function go(n) {
      i = (n + total) % total;
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, idx) => {
        d.style.width = idx === i ? '1.5rem' : '0.5rem';
        d.style.backgroundColor = idx === i ? 'var(--gold)' : '';
      });
    }
    let timer = setInterval(() => go(i + 1), 6000);
    root.querySelectorAll('[data-testimonial-prev]').forEach((b) => b.addEventListener('click', () => { clearInterval(timer); go(i - 1); timer = setInterval(() => go(i + 1), 6000); }));
    root.querySelectorAll('[data-testimonial-next]').forEach((b) => b.addEventListener('click', () => { clearInterval(timer); go(i + 1); timer = setInterval(() => go(i + 1), 6000); }));
    dots.forEach((d, idx) => d.addEventListener('click', () => { clearInterval(timer); go(idx); timer = setInterval(() => go(i + 1), 6000); }));
  });

  // ---------- Newsletter ----------
  window.handleNewsletter = function (e) {
    e.preventDefault();
    const form = e.currentTarget;
    const success = document.getElementById('newsletter-success');
    if (success) {
      form.classList.add('hidden');
      success.classList.remove('hidden');
      success.classList.add('animate-fade-up');
    }
  };
  window.copyCode = function (code) {
    navigator.clipboard.writeText(code).then(() => {
      const el = document.getElementById('copy-feedback');
      if (el) {
        el.textContent = 'Copied!';
        setTimeout(() => { el.textContent = 'Copy Code'; }, 2000);
      }
    });
  };

  // ---------- Live Chat ----------
  window.toggleChat = function () {
    const w = document.getElementById('chat-window');
    if (!w) return;
    w.classList.toggle('hidden');
    w.classList.toggle('flex');
  };
  window.minimizeChat = function () {
    const body = document.getElementById('chat-body');
    if (!body) return;
    body.classList.toggle('hidden');
  };
  const chatReplies = {
    "What's the best lock for Airbnb?": "For Airbnb properties, I recommend the YR-L1 Lite at $129. It's perfect for remote guest management with easy code changes. Would you like to see it?",
    "Do you ship internationally?": "Yes! We ship to 50+ countries worldwide. Orders over $150 qualify for free shipping. Where are you located?",
    "How does installation work?": "Installation is DIY-friendly and takes about 15 minutes. We include a step-by-step video guide. Most customers install it themselves!",
    "Return policy question": "We offer a 30-day money-back guarantee, no questions asked. If you're not satisfied, just return it for a full refund.",
  };
  window.sendChat = function (text) {
    const messagesEl = document.getElementById('chat-messages');
    if (!messagesEl || !text.trim()) return;
    const now = new Date();
    const time = `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
    messagesEl.insertAdjacentHTML('beforeend', `
      <div class="flex justify-end"><div class="max-w-[80%] rounded-2xl rounded-br-sm bg-gold text-navy px-4 py-2"><p class="text-sm">${text}</p><p class="mt-1 text-xs text-navy/60">${time}</p></div></div>
    `);
    const reply = chatReplies[text] || "Thanks for your message! Our team will get back to you shortly. In the meantime, feel free to browse our products or take our quiz to find your perfect lock.";
    document.getElementById('chat-input').value = '';
    setTimeout(() => {
      messagesEl.insertAdjacentHTML('beforeend', `
        <div class="flex justify-start"><div class="max-w-[80%] rounded-2xl rounded-bl-sm bg-white dark:bg-navy text-navy dark:text-cream shadow-sm px-4 py-2"><p class="text-sm">${reply}</p><p class="mt-1 text-xs text-muted-foreground">${time}</p></div></div>
      `);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      const qr = document.getElementById('chat-quickreplies');
      if (qr) qr.classList.add('hidden');
    }, 1000);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  };
  window.submitChat = function (e) {
    e.preventDefault();
    const input = document.getElementById('chat-input');
    sendChat(input.value);
  };

  // ---------- Fixed CTA visibility ----------
  const fixedCta = document.querySelector('[data-fixed-cta]');
  if (fixedCta) {
    const onScroll = () => {
      const heroHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      const viewportHeight = window.innerHeight;
      const distanceFromBottom = pageHeight - scrollY - viewportHeight;
      if (scrollY > heroHeight && distanceFromBottom > 200) {
        fixedCta.style.transform = 'translateY(0)';
      } else {
        fixedCta.style.transform = 'translateY(100%)';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Language switcher ----------
  window.toggleLangMenu = function (id) {
    const menu = document.getElementById(id);
    if (!menu) return;
    menu.classList.toggle('hidden');
  };
  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-lang-menu]').forEach((menu) => {
      if (!menu.contains(e.target) && !e.target.closest('[data-lang-toggle]')) {
        menu.classList.add('hidden');
      }
    });
  });

  // ---------- Compare modal ----------
  window.openCompare = function () {
    const m = document.getElementById('compare-modal');
    if (m) { m.classList.remove('hidden'); document.body.style.overflow='hidden'; }
  };
  window.closeCompare = function () {
    const m = document.getElementById('compare-modal');
    if (m) { m.classList.add('hidden'); document.body.style.overflow=''; }
  };
  window.toggleCompare = function (id) {
    const btn = document.querySelector(`[data-compare-id="${id}"]`);
    if (!btn) return;
    btn.classList.toggle('is-selected');
    const all = document.querySelectorAll('[data-compare-id].is-selected');
    const compare = document.getElementById('compare-bar');
    if (compare) {
      compare.classList.toggle('hidden', all.length === 0);
      const counter = document.getElementById('compare-count');
      if (counter) counter.textContent = all.length;
    }
  };

  // ---------- 360 viewer ----------
  window.open360 = function (image, name) {
    const m = document.getElementById('viewer360-modal');
    if (!m) return;
    const rotor = document.getElementById('viewer360-rotor');
    if (rotor) rotor.style.transform = 'perspective(1000px) rotateY(0deg)';
    document.getElementById('viewer360-image').src = image;
    document.getElementById('viewer360-name').textContent = `360° View - ${name}`;
    m.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    const stage = document.getElementById('viewer360-stage');
    let rotation = 0;
    let isDragging = false;
    let lastX = 0;
    function onDown(e) {
      isDragging = true;
      lastX = e.clientX;
      try { e.target.setPointerCapture(e.pointerId); } catch (_) {}
    }
    function onMove(e) {
      if (!isDragging) return;
      const delta = e.clientX - lastX;
      rotation += delta * 0.5;
      lastX = e.clientX;
      if (rotor) rotor.style.transform = `perspective(1000px) rotateY(${rotation}deg)`;
    }
    function onUp(e) {
      isDragging = false;
      try { e.target.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    stage.onpointerdown = onDown;
    stage.onpointermove = onMove;
    stage.onpointerup = onUp;
    stage.onpointerleave = onUp;
  };
  window.close360 = function () {
    const m = document.getElementById('viewer360-modal');
    const rotor = document.getElementById('viewer360-rotor');
    if (m) { m.classList.add('hidden'); document.body.style.overflow=''; }
    if (rotor) { rotor.style.transform = 'perspective(1000px) rotateY(0deg)'; }
  };

  // ---------- Footer accordion (mobile) ----------
  window.toggleFooterSection = function (id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.toggle('hidden');
  };

  // ---------- Currency/Language selector (footer) ----------
  window.toggleFooterSelect = function (id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.toggle('hidden');
  };
})();
